import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const updateProfileFunction = createAsyncThunk(
  'profile/updateProfile',
  async (profileData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post('/api/user/profile', profileData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const initialState = {
  updateProfile: null,
  status: "idle",
  error: null,
};

const profileUpdateSlice = createSlice({
  name: "updateProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateProfileFunction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateProfileFunction.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.updateProfile = action.payload;
      })
      .addCase(updateProfileFunction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default profileUpdateSlice.reducer;